import * as localForage from 'localforage';
import localforage from 'localforage';

export class StorageManager {
    instances: [LocalForage, string][] = [];
    public static DEFAULT = localforage.LOCALSTORAGE;
    addInstance(instance: LocalForage) {
        this.instances.push([instance, instance.driver()]);
    }
}

export const StorageType = {
    LOCAL_STORAGE: 'localStorage',
    SESSION_STORAGE: 'sessionStorage',
    MEMORY: 'memory',
};

export const storageManger = new StorageManager();

export function createStorageInstance(options: LocalForageOptions): LocalForage {
    const defaultOptions = {
        driver: StorageManager.DEFAULT,
        storeName: 'storage', // 指定なしだとlocalStorageと他ストレージを使用した時の挙動が異なってしまうため、指定しておく
    };

    const instance = localForage.createInstance(Object.assign(defaultOptions, options));
    storageManger.addInstance(instance);
    return instance;
}
